module.exports = __webpack_public_path__ + "static/topagentnetwork-c46a71794b9bc9724f767ece22cb9540.png";